import { useParams, Navigate, Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const Layout = () => {
  const { lng } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lng && i18n.language !== lng) {
      i18n.changeLanguage(lng);
      localStorage.setItem("lng", lng);
    } else if (!lng && i18n.language !== "az") {
      i18n.changeLanguage("az");
      localStorage.setItem("lng", "az");
    }
  }, [lng, i18n]);

  const supportedLangs = ["en", "ru"];
  if (lng && !supportedLangs.includes(lng)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default Layout;
